// Minimal toast/undo helper (the first just-in-time UI primitive; reused by any
// phase that needs transient feedback or undo). CSP-safe: built with the DOM
// builder, styled by external CSS.
import { h } from '../core/dom';

let hostEl: HTMLElement | null = null;

function host(): HTMLElement {
	if (!hostEl || !hostEl.isConnected) {
		// A polite live region so screen readers announce toasts (incl. undo).
		hostEl = h('div', { class: 'toast-host', role: 'status', 'aria-live': 'polite' });
		document.body.append(hostEl);
	}
	return hostEl;
}

export interface ToastOptions {
	undo?: () => void;
	ms?: number;
}

export function toast(message: string, opts: ToastOptions = {}): void {
	let timer: ReturnType<typeof setTimeout>;
	const dismiss = () => {
		clearTimeout(timer);
		el.remove();
	};
	const el = h(
		'div',
		{ class: 'toast' },
		h('span', {}, message),
		opts.undo
			? h(
					'button',
					{
						class: 'btn btn-sm btn-link',
						onclick: () => {
							opts.undo?.();
							dismiss();
						},
					},
					'Undo'
				)
			: null
	);
	host().append(el);
	timer = setTimeout(dismiss, opts.ms ?? 5000);
}
